export const userAccessResources_actionType = {
    USER_ACCESS_RESOURCES: 'USER_ACCESS_RESOURCES',
    USER_ACCESS_RESOURCES_SUCCESS: 'USER_ACCESS_RESOURCES_SUCCESS',
    USER_ACCESS_RESOURCES_ERROR: 'USER_ACCESS_RESOURCES_ERROR',
    RESET_USER_ACCESS_RESOURCES: 'RESET_USER_ACCESS_RESOURCES'
};